import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import NotFound from './pages/NotFound';
import usePageMeta from './hooks/usePageMeta';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <AppContent />
        </Router>
        <BetaLabel />
      </LanguageProvider>
    </ThemeProvider>
  );
}

// Beta label component with animation
const BetaLabel = () => {
  const { t } = useLanguage();
  
  return (
    <div className="beta-wrapper">
      <div className="beta-label">
        <span className="beta-text">BETA</span>
        <div className="beta-card">
          <p>{t('beta', 'description') || 'This website is in beta. Some features may not work as expected.'}</p>
        </div>
      </div>
    </div>
  );
};

// Separate component to use hooks that require router context
const AppContent = () => {
  usePageMeta(); // Use our custom hook here
  
  return (
    <div className="container">
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
